import type { ComponentProps } from "react";

import { cn } from "@/shared/lib/cn";

export function Field({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      data-slot="field"
      className={cn("grid gap-1.5", className)}
      {...props}
    />
  );
}

export function FieldDescription({ className, ...props }: ComponentProps<"p">) {
  return (
    <p
      data-slot="field-description"
      className={cn(
        "m-0 text-xs leading-snug text-foreground-muted",
        className,
      )}
      {...props}
    />
  );
}

export function FieldError({ className, ...props }: ComponentProps<"p">) {
  return (
    <p
      data-slot="field-error"
      className={cn("m-0 text-xs font-semibold text-danger", className)}
      {...props}
    />
  );
}
